export default __webpack_public_path__ + "static/media/aquatic.7cbc8964.jpg";